<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-white py-1 shadow-sm sticky-top">
       
      <div class="container d-flex flex-column align-items-center position-relative">
      <div class="navbar-brand-wrapper d-flex flex-column align-items-center">

        <router-link class="navbar-brand d-flex justify-content-center align-items-center" to="/">
          <template v-if="!isLoggedInLogo">
            <img src="@/assets/logo.png" alt="Make Me Hero" class="logo-img" style="width: 140px; height: auto;" />
          </template>
          <template v-else>
            <div class="user-logo-circle d-flex justify-content-center align-items-center">
              {{ userInitial }}
            </div>
          </template>
        </router-link>
       <div class="tagline    " >
  — Where Imagination Meets Identity — 
</div>

        </div>
       <div v-if="couponMessageLeft" class="coupon-message-below-logo w-100 text-center d-lg-none"> 🎊 {{ couponMessageLeft }} 
       </div>

        <div class="d-flex d-lg-none align-items-center justify-content-between w-100 mb-2">
          
          <ul class="navbar-nav flex-row gap-3 mb-0">
            <li class="nav-item">
              <router-link class="nav-link fw-semibold p-0" to="/" :class="{ active: $route.path === '/' }">
                Home
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold p-0" to="/books" :class="{ active: $route.path === '/books' }">
                Kids Books
              </router-link>
            </li>
          </ul>

          <div class="d-flex align-items-center gap-2 ms-auto"> 
            
            <div class="user-icon-content p-0">


            <!--UserLogin  --> 
            <!--
              <router-link
                v-if="!isLoggedIn"
                to="/login"
                class="nav-link p-0 login-icon-link"
                aria-label="Login or User Profile"
              >
                <i class="bi bi-person-circle fs-3"></i>
              </router-link>

              <div v-else class="dropdown">
                <a
                  class="nav-link dropdown-toggle d-flex align-items-center p-0"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    v-if="user.avatar && user.avatar.length > 0"
                    :src="user.avatar"
                    alt="User Avatar"
                    class="rounded-circle me-2"
                    width="35"
                    height="35"
                  />
                  <span v-else class="user-initial-circle-small me-2">
                    {{ userInitial }}
                  </span>
                  
                  <span class="fw-semibold d-none d-sm-inline">{{ user.name }}</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-end" >
                  <li>
                    <router-link class="dropdown-item" to="/profile">Profile</router-link>
                  </li>
                  <li>
                    <button class="dropdown-item" @click="logoutUser">Logout</button>
                  </li>
                </ul>
              </div>
              -->


            </div>

            <button
              class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            
          </div>
        </div>

        <div class="collapse navbar-collapse  justify-content-center" id="navbarNav">
          <ul class="navbar-nav gap-3 text-center" >
            <li class="nav-item" >
              <router-link class="nav-link fw-semibold" to="/" :class="{ active: $route.path === '/' }" @click="closeMobileMenu" > Home </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" to="/books" :class="{ active: $route.path === '/books' }"@click="closeMobileMenu"> Kids Books </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" to="/about" :class="{ active: $route.path === '/about' }" @click="closeMobileMenu"> About Us </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" to="/blogs" :class="{ active: $route.path === '/blogs' }" @click="closeMobileMenu"> Blogs </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" to="/reviews" :class="{ active: $route.path === '/reviews' }" @click="closeMobileMenu"> Reviews </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" to="/contact" :class="{ active: $route.path === '/contact' }" @click="closeMobileMenu"> Info & Contact Us </router-link>
            </li>
          </ul>
        </div>
        
      </div>
      
      <div class="user-icon-container d-none d-lg-flex justify-content-end align-items-center">

      <!--UserLogin  -->
      <!--
        <router-link
          v-if="!isLoggedIn"
          to="/login"
          class="nav-link p-0 login-icon-link"
          aria-label="Login or User Profile"
        >
          <i class="bi bi-person-circle fs-3"></i>
        </router-link>

        <div v-else class="dropdown">
          <a
            class="nav-link dropdown-toggle d-flex align-items-center p-0"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              v-if="user.avatar && user.avatar.length > 0"
              :src="user.avatar"
              alt="User Avatar"
              class="rounded-circle me-2"
              width="35"
              height="35"
            />
            <span v-else class="user-initial-circle-small me-2">
              {{ userInitial }}
            </span>
            
            <span class="fw-semibold">{{ user.name }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <router-link class="dropdown-item" to="/profile">Profile</router-link>
            </li>
            <li>
              <button class="dropdown-item" @click="logoutUser">Logout</button>
            </li>
          </ul>
        </div>
        -->

      </div>

       

<div v-if="couponMessageRight" class="coupon-message-right align-items-center px-3 d-none d-lg-flex"> 🎉 {{ couponMessageRight }} </div> 
<div v-if="couponMessageLeft" class="coupon-message-left align-items-center px-3 d-none d-lg-flex"> 🎊{{ couponMessageLeft }} </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useAuthStore } from "@/stores/auth"; 
import axios from "axios";

const authStore = useAuthStore();
const isLoggedIn = computed(() => authStore.isAuthed); 
const isLoggedInlogoo = computed(() => authStore.isAuthed); 
const user = computed(() => authStore.user || {}); 

const closeMobileMenu = () => {
  const navbarCollapse = document.getElementById('navbarNav');
  const navbarToggler = document.querySelector('.navbar-toggler');
  
  if (navbarCollapse && navbarCollapse.classList.contains('show')) {
    if (window.bootstrap) {
      const collapseInstance = window.bootstrap.Collapse.getInstance(navbarCollapse);
      if (collapseInstance) {
        collapseInstance.hide();
      }
    }
    
    else if (navbarToggler) {
      navbarToggler.click();
    }
   
    else {
      navbarCollapse.classList.remove('show');
    }
  }
};


const userInitial = computed(() => {
  const name = user.value?.name || user.value?.contactName || user.value?.email;
  if (!name) return 'U';
  return name.charAt(0).toUpperCase(); 
});

const couponMessageLeft = ref("");
const couponMessageRight = ref("");
const couponCode = ref("");
const hasActiveCoupon = computed(() => { return !!couponMessageLeft.value || !!couponMessageRight.value; });

async function fetchCouponMessage() {
  try {
    const res = await axios.post("https://api.craftmystories.com/orders/get-active-coupon-message", {
      currency: "INR"  
    });
    
    console.log("Coupon API response:", res.data);
    
    // Clear messages first
    couponMessageLeft.value = "";
    couponMessageRight.value = "";
    couponCode.value = "";
    
    // Only set messages if we have valid data
    if (res.data.found && res.data.coupon_code) {
      // Set left message only if message1 exists and is not empty
      if (res.data.message1 && res.data.message1.trim().length > 0) {
        couponMessageLeft.value = res.data.message1;
      }
      
      // Set right message only if message2 exists and is not empty
      if (res.data.message2 && res.data.message2.trim().length > 0) {
        couponMessageRight.value = res.data.message2;
      }
      
      couponCode.value = res.data.coupon_code;
    }
  } catch (err) {
    console.error("Error fetching coupon:", err);
    couponMessageLeft.value = "";
    couponMessageRight.value = "";
    couponCode.value = "";
  }
}
onMounted(() => {
  fetchCouponMessage();
});
function logoutUser() {
  authStore.logout();
}
</script>

<style scoped>


.user-logo-circle {
  width: 50px;
  height: 50px;
  background-color: #ff6600;
  color: #fff;
  font-size: 25px; 
  font-weight: bold;
  border-radius: 50%;
  text-transform: uppercase;
  display: flex; 
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.user-logo-circle:hover {
  background-color: #e05500;
}

/* Style for the Profile Dropdown Initial (Small Circle) */
.user-initial-circle-small {
  width: 35px;
  height: 35px;
  border-radius: 50%; 
  background-color: #007bff; 
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px; 
  line-height: 1; 
  text-transform: uppercase;
}
/* Tagline now uses the coupon style */
.tagline {
  font-size: 1rem;
  font-weight: 600;
  color: #2a6099;
  font-family: 'Aptos', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  margin-top: -8px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

/* Coupon messages now use the tagline style */
.coupon-message-below-logo,
.coupon-message-left,
.coupon-message-right {
  color: #28a745 !important;
  text-align: center;
  text-shadow: 1px 1px 2px #fff;
   animation: twinkle 2s infinite alternate;
  font-size: 0.9rem;
  font-weight: 600;
  gap: 4px;
  line-height: 1.2;
}


.coupon-message-left,
.coupon-message-right  {
  color: #28a745; 
  font-weight: 700;
}

.coupon-message-left::before {
  //content: "🎄";
 
}

.coupon-message-right::after {
  //content: "🎅";
 
}

/* Positioning */
.coupon-message-left {
  position: absolute;
  left: 20px;
  top: 40%;
  transform: translateY(-50%);
}

.coupon-message-right {
  position: absolute;
  right: 20px;
  top: 40%;
  transform: translateY(-50%);
}


@keyframes couponBounce {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0);
  }
}



.navbar-brand {
  margin-right: 0 !important;
}

/* DESKTOP USER ICON CONTAINER  */
.user-icon-container {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 100;
  
}

.login-icon-link {
  color: #333 !important;
  transition: color 0.3s ease;
}

.login-icon-link:hover {
  color: #ff6600 !important;
}

.nav-link {
  color: #333 !important;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #ff6600 !important;
}

.nav-link.active {
  color: #ff6600 !important;
}

.user-icon-container .bi-person-circle {
  font-size: 1.75rem; 
}
@media (max-width: 768px) {
  .tagline {
  font-size: 0.8rem;
  font-weight: 600;
  color: #2a6099;
  font-family: 'Aptos', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  margin-top: -8px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
  .coupon-message-left,
  .coupon-message-right {
    position: static;          
    display: block;           
    max-width: 100%;           
    font-size: 0.9rem;         
    text-align: center;        
    margin: 6px 0;            
    white-space: normal;       
    word-break: break-word;    
  }

  .coupon-message-below-logo {
    white-space: normal;       
    overflow: visible;         
    text-overflow: unset;      
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .navbar .container {
    flex-direction: column;    
    align-items: center;
  }
}
</style>